import { Link } from "react-router-dom";

const estimagas = '/images/estimagas-logo-titulo.svg'

export default function Header(props) {  
  const { isInverted, toggleInvert, size} = props

    return (
        <header className={`bg-white transition-colors`}>
            <nav className={``}>
              <div className="container mx-auto">
                <ul className="flex justify-between py-2 text-sm">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="https://www.proclima2050.rs.gov.br/inicial" target="_blank" rel="noopener noreferrer">PROCLIMA2050</Link></li>
                    <li><Link to="https://www.rs.gov.br/" target="_blank" rel="noopener noreferrer">SERVIÇOS</Link></li>
                    <li><Link to="/acessibilidade">Acessibilidade</Link></li>
                    <button
                            onClick={toggleInvert}
                            className="px-4 rounded hover:bg-blue-200 transition-colors"
                    >
                      {isInverted ? 'Reverter Cores' : 'Inverter Cores'}
                    </button>
                </ul>
              </div>
            </nav>
            <div className="container mx-auto">              
              <div className="flex items-center justify-center my-8 py-4">
                        <img src={estimagas} alt="Logo do estimagas" className={'h-' + size} />
              </div>
            </div>
        
          </header>
        );
}